export default __webpack_public_path__ + "static/media/elk.fbf2bff6.png";